import styled from "styled-components";
import { FlexGrowProps } from "styled-system";

import Box from "../Box";
import { Link } from "react-router-dom";
import MrclText from "../marcel/MrclText";

type TabProps = {
  isActive: boolean;
  tabName: string;
  page?: string;
  search?: string;
  width?: string;
  colorInactive?: string;
} & FlexGrowProps;
interface ComponentProps {
  $isActive: boolean;
  $width: string;
  $colorInactive: string;
}
const TabContainer = styled(Box)`
  cursor: pointer;
  display: flex;
  align-items: end;
  justify-content: center;
`;

const LinkCustom = styled(Link)<ComponentProps>`
  text-decoration: none;
  height: 100%;
  border-bottom-width: ${(props) => (props.$isActive ? "3px" : "2px")};
  border-bottom-color: ${(props) =>
    props.$isActive
      ? "#0970E6"
      : props.$colorInactive
      ? props.$colorInactive
      : "transparent"};
  border-bottom-style: solid;
  width: ${(props) => (props.$width ? props.$width : "auto")};
`;

const Tab = ({
  tabName,
  page,
  search,
  isActive,
  width,
  colorInactive,
}: TabProps) => {
  return (
    <LinkCustom
      data-testid={tabName}
      to={{
        pathname: page,
        search: search,
      }}
      $isActive={isActive}
      $width={width || "auto"}
      $colorInactive={colorInactive || ""}
    >
      <TabContainer width={"auto"} height="100%" p="6px 16px">
        <MrclText size={"s"} tagStyle="p" bold={isActive}>
          {tabName}
        </MrclText>
      </TabContainer>
    </LinkCustom>
  );
};

export default Tab;
